import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  fetchAllData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Category = () => {
  const [editData, setEditData] = useState({
  });
  const [createData, setCreateData] = useState(false);

  const [categoryTitle, setcategoryTitle] = useState("");
  const [categoryActive, setcategoryActive] = useState("");
  const [categoryIcon, setcategoryIcon] = useState("");
  const [showImage, setShowImage] = useState(null);
  const [sortcategoryOrder, setsortcategoryOrder] = useState(0);
  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      //    console.log('imageUrl',imageUrl)
      setcategoryIcon(file);
      setShowImage(imageUrl);
      UploadImage(file);
    }


  };


  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    fetchCategoryList();
  }, []);

  const fetchCategoryList = async () => {
    let url = `${endPoints.api.GET_CATEGORY}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response?.status === "success") {
          setRows(response?.data);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setcategoryIcon(result?.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const handleOk = () => {
    //nestUnder
    if (categoryTitle && categoryIcon) {
      let url = editData?.cat_id
        ? `${endPoints.api.UPDATA_CATEGORY}`
        : `${endPoints.api.ADD_CATEGORY}`;
      let payload = {
         category: categoryTitle,
         categoryIcon: categoryIcon, // showImage,
         rotate: Number(categoryActive),
         sort: Number(sortcategoryOrder),
      };

      if (editData?.cat_id) {
        payload.cat_id = editData.cat_id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response?.data?.status === "success") {
            SuccesToast(response?.data?.message);
            fetchCategoryList();

            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    }
    else {
      ErrorToast("All fields are required");
    }
  };


  useEffect(() => {
    if (editData) {
      setcategoryTitle(editData?.category || '');
      let imageFullPath = editData.categoryIcon !== undefined ? `${endPoints.apiBaseUrl}${editData.categoryIcon}` : '';
      setShowImage(imageFullPath || '');
      setcategoryIcon(editData.categoryIcon);
      setcategoryActive(editData?.rotate?"1":"0" || '');
      setsortcategoryOrder(editData?.sort || '');
    }
  }, [editData]);



  const handleSwitchChange = (row, param, value) => {

    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updateCategory(updatedRow)

  };

  const updateCategory = (payload) => {

    const id = payload.id;
    let url = `${endPoints.api.UPDATA_CATEGORY}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchCategoryList();

          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  }

  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState('');

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter(item =>
        item.category.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;


  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12" style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #444" }}>
                  <h3 className="mb-2 heading-table" style={{ fontFamily: "ArticulatCF-Bold" }}>
                    Categories
                  </h3>

                </div>

              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: '10px', width: '25%' }}
                    placeholder="Enter Category Title..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        // aria-label="a dense table"
                        stickyHeader
                        // aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Category ID</TableCell>
                            <TableCell align="center">Category Title</TableCell>
                            {/* <TableCell align="center">Nest Under</TableCell> */}
                            {/* <TableCell align="center">Sort Order</TableCell> */}
                            {/* <TableCell align="center">Active</TableCell> */}
                            <TableCell align="center">Sort Order</TableCell>
                            <TableCell align="center">Rotate Category</TableCell>
                            <TableCell align="center">Category Icon</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">{row?.cat_id}</TableCell>
                              <TableCell align="center">{row?.category}</TableCell>
                              <TableCell align="center">{row?.sort}</TableCell>
                              <TableCell align="center">{row?.rotate?"Active":"Inactive"}</TableCell>
                              <TableCell align="center">
                                <img src={`${DefaultImageBaseurl}${row?.categoryIcon}`} style={{ height: "50px" }} />
                              </TableCell>

                              <TableCell align="center">
                                <EditIcon onClick={() => {
                                  setShow(true);
                                  setCreateData(true);
                                  setEditData(row);
                                }}
                                  style={{ cursor: 'pointer' }}
                                />
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      style={{ marginTop: "10%" }}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Category
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Category Title </Form.Label>
                              <Form.Control type="text" placeholder="Category Title" value={categoryTitle} onChange={(event) => {
                                setcategoryTitle(event.target.value);
                              }} />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Category Sort Order </Form.Label>
                              <Form.Control 
                                type="number" 
                                placeholder="Category Sort Order" 
                                value={sortcategoryOrder}
                                onChange={(event) => {
                                  const value = event.target.value;
                                  if(value === "" || value > 0) {
                                    setsortcategoryOrder(value);
                                  }
                                }} 
                                onKeyDown={(event) => {
                                  // Prevent typing e, E, +, -, .
                                  if (['e', 'E', '+', '-', '.'].includes(event?.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Category Icon Creative </Form.Label>
                              <Form.Control type="file" placeholder="xxxxx" onChange={handleFileChange} />

                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            {showImage && (
                              <div>
                                <img src={showImage} alt="Selected" style={{ maxWidth: '100px' }} />
                              </div>
                            )}
                          </div>

                             <div className="col-md-6">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Category Rotate </Form.Label>
                              <Form.Select value={categoryActive} onChange={(event) => {
                                setcategoryActive(event.target.value);
                              }} >
                                <option value="">Select Rotate Category</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </Form.Select>
                            </Form.Group>
                          </div>

                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShowImage(null);
                    setShow(true);
                    setEditData({})
                    setCreateData(true);
                  }}
                >
                  Add New Category
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
